import React, { FC, Key, ReactElement, useContext } from 'react';
import { ExpandableTableContext } from './ExpandableTableContext';

interface IExpandableRowsContainerProps<T> {
  Component: FC<T>;
  data: T[];
  keyBy?: keyof T | ((item: T) => string);
}

export const ExpandableRowsContainer = <T extends {}>({
  data,
  Component,
  keyBy,
}: IExpandableRowsContainerProps<T>): ReactElement => {
  const context = useContext(ExpandableTableContext);

  const slice = context?.rowsCount == null ? data : data.slice(0, context.rowsCount);

  return (
    <>
      {slice.map((item, index) => {
        let key: string = String(index);

        if (typeof keyBy === 'function') {
          key = keyBy(item);
        }

        if (typeof keyBy === 'string' || typeof keyBy === 'number' || typeof keyBy === 'symbol') {
          key = String(item[keyBy]);
        }

        return <Component key={key as Key} {...item} />;
      })}
    </>
  );
};
